module.exports = __webpack_public_path__ + "static/media/logoorigensbrasil.3d4f8ce7.png";